// // components/live-auction/PreviewLiveAuctionDetail.jsx
// import React, { useState, useEffect } from "react";
// import CircularProgress from "../live-auction/live-auction-detail/ui/CircularProgress";
// import QuickBidsDummy from "./QuickBidsDummy";
// import BidInput from "../live-auction/live-auction-detail/BidInput";
// import VehicleDetails from "../live-auction/live-auction-detail/tables/VehicleDetails";
// import VerticleSwiper from "../live-auction/live-auction-detail/ui/VerticleSwiper";
// import SwiperMobView from "../live-auction/live-auction-detail/ui/SwiperMobView";
// import { FaBagShopping } from "react-icons/fa6";
// import { CiLocationOn } from "react-icons/ci";
// import { MdPeopleAlt } from "react-icons/md";
// import TooltipGlobal from "../live-auction/live-auction-detail/ui/tooltip/TooltipGlobal";
// import {
//   IoInformationCircleOutline,
//   IoVolumeHigh,
//   IoVolumeMute,
// } from "react-icons/io5";
// import SimpleCircularTimer from "./SimpleCircularTimer";
// import { ClipLoader } from "react-spinners";
// import AuctionBidDetailsShimmer from "./AuctionBidDetailsShimmer";

// const PreviewLiveAuctionDetail = ({ car, loading }) => {
//   console.log("PreviewLiveAuctionCard loading:", loading, "car:", car);
//   const [manualBid] = useState(car?.currentBid || 0);
//   const [countdown, setCountdown] = useState("");

  

//   useEffect(() => {
//     if (!car?.auction_date) return;
//     const targetDate = new Date(car.auction_date);

//     const interval = setInterval(() => {
//       const now = new Date();
//       const diff = targetDate - now;

//       if (diff <= 0) {
//         setCountdown("Auction Started");
//         clearInterval(interval);
//         return;
//       }

//       const minutes = Math.floor((diff / 1000 / 60) % 60);
//       const seconds = Math.floor((diff / 1000) % 60);
//       setCountdown(`${minutes} min ${seconds} sec`);
//     }, 1000);

//     return () => clearInterval(interval);
//   }, [car?.auction_date]);

//   if(loading){
//     return <AuctionBidDetailsShimmer loading={false}/>
//   }


//   return (
    
//     <div className="bg-gray-100 w-full py-[3vw] mt-[4vw]">
//       <div className="w-[90%] lg:max-w-[85vw] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-[1vw]">
//         {/* Left Section */}
//         <div className="col-span-7 space-y-[1vw]">
//           {/* Header */}
//           <div className="flex flex-wrap lg:flex-nowrap justify-between mt-16 lg:mt-0 items-center bg-white p-[1vw] rounded-md">
//             <div className="flex items-center">
//               <h2 className="lg:text-[1.5vw] font-bold mr-4 lg:mr-[0.5vw]">
//                 {car?.make} {car?.model} {car?.year}
//               </h2>
//               <div className="bg-yellow-200 text-gray-800 px-[0.75vw] py-[0.25vw] rounded-full flex items-center lg:text-[1vw]">
//                 <CiLocationOn className="mr-[0.5vw]" />
//                 {car?.carState} {car?.carLocation}
//               </div>
//             </div>
//             <div className="flex items-center gap-[0.5vw] lg:text-[1vw] text-gray-700">
//               <MdPeopleAlt />
//               <span>1</span>
//             </div>
//           </div>
//           <div className="lg:w-[25%] lg:hidden w-full">
//             {/* <VerticleSwiper images={car?.carImages} /> */}
//             <SwiperMobView images={car?.carImages} />
//           </div>

//           {/* Images and Bidding UI */}
//           <div className="flex gap-[1vw]">
//             <div className="lg:w-[25%] lg:block hidden w-full">
//               <VerticleSwiper images={car?.carImages || []} />
//             </div>

//            <div className="w-[100%] lg:w-[40vw] bg-white p-[8px] lg:p-[0.8vw] h-full rounded-md shadow-sm flex  lg:flex-row  justify-between  gap-[1vw]">
//   {/* Timer + Bid Controls */}
//   <div className="flex flex-col justify-center items-center w-full lg:w-1/2 space-y-[0.5vw]">
//     <h2 className="font-lg lg:mt-3">Going Live In:</h2>
//     <div className="relative flex justify-center items-center lg:ml-8 lg:mt-6">
//       <SimpleCircularTimer auctionDate={car?.auction_date} />
//     </div>
//     <div className="flex items-center gap-[0.5vw] mt-[0.5vw]">
//       <input
//         value={manualBid}
//         readOnly
//         disabled
//         className="w-[40px] lg:w-[4vw] border border-gray-300 bg-gray-200 text-gray-500 rounded text-center lg:text-[1vw] cursor-not-allowed"
//       />
//       <button
//         disabled
//         className="w-[40px] lg:w-full lg:text-[1vw] border border-gray-300 bg-gray-200 text-gray-500 px-[0.5vw] py-[0.25vw] rounded cursor-not-allowed"
//       >
//         −
//       </button>
//       <button
//         disabled
//         className="w-[40px] lg:w-full lg:text-[1vw] border border-gray-300 bg-gray-200 text-gray-500 px-[0.5vw] py-[0.25vw] rounded cursor-not-allowed"
//       >
//         +
//       </button>
//     </div>
//   </div>

//   {/* Quick Bids Section */}
//   <div className="w-full lg:w-1/2 p-[1vw] flex justify-end">
//     <QuickBidsDummy manualBid={manualBid} setManualBid={() => {}} />
//   </div>
// </div>

//           </div>

//           {/* Place Bid & Auto-Bid */}
//           <div className="flex flex-col items-end mt-[1vw] ">
//             <div className="w-[100%] lg:w-[75%]    rounded-md shadow-sm">
//               <button
//                 disabled
//                 className="w-full text-[12px] lg:text-18 flex items-center justify-center gap-2 py-[10px] lg:py-[0.677vw] bg-gray-200 text-gray-500 border border-gray-300 rounded-md md:rounded-[0.5vw] cursor-not-allowed"
//               >
//                 <FaBagShopping />
//                 Place Bid
//               </button>

//               <div className="mt-[1vw]">
//                 <label className="lg:text-[1vw] text-left  font-medium block mb-[0.5vw]">
//                   Auto Bid For Me
//                 </label>
//                 <div className="flex items-center border rounded-md md:rounded-[0.5vw] px-3 py-2 bg-white w-full">
//                   <input
//                     type="text"
//                     disabled
//                     placeholder="Enter maximum amount"
//                     className="focus:outline-none text-[12px] lg:text-16 p-[1vw] lg:py-[0.317vw] bg-gray-200 border border-gray-300 text-gray-500 w-full rounded cursor-not-allowed"
//                   />
//                   <TooltipGlobal
//                     title="Dynamic Bidding Guide"
//                     description="The incremental bid based on the vehicles value is as follows:"
//                     tableData={[
//                       { range: "1 - 5", increment: "1" },
//                       { range: "5 - 40", increment: "5" },
//                       { range: "40 - 100", increment: "10" },
//                       { range: "100 - 1,000", increment: "25" },
//                       { range: "1,000 - 5,000", increment: "50" },
//                       { range: "5,000 - 25,000", increment: "100" },
//                       { range: "25,000 - 50,000", increment: "250" },
//                       { range: "50,000 - 100,000", increment: "500" },
//                       { range: "100,000 - 9,999,999", increment: "1,000" },
//                     ]}
//                     customStyles={{
//                       color: "#fff",
//                       headerStyles: { fontSize: "18px" },
//                       paragraphStyles: { fontSize: "14px", color: "#fff" },
//                     }}
//                     placement="left"
//                     hoverComponent={
//                       <span className="cursor-pointer text-[14px] lg:text-20">
//                         <IoInformationCircleOutline />
//                       </span>
//                     }
//                   />
//                 </div>
//               </div>
//             </div>
//             <div className=" flex items-start space-x-1 w-[100%] lg:w-[75%] lg:mt-[1vw]">
//               <button
//                 disabled
//                 className="px-2 lg:px-[0.5vw] py-1 lg:py-[0.25vw] rounded-md md:rounded-[0.5vw] bg-gray-400 text-[12px] my-[10px] lg:my-auto  lg:text-14 "
//               >
//                 Enable Auto-Bid
//               </button>

//               <button
//                 disabled
//                 className="px-2 lg:px-[0.5vw] py-1 lg:py-[0.25vw] rounded-md md:rounded-[0.5vw] text-[12px] my-[10px] lg:text-14 bg-gray-600 text-white hover:bg-gray-700"
//               >
//                 Disable Auto-Bid
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* Right Section */}
//         <div className="col-span-5">
//           <VehicleDetails vehicle={car} />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PreviewLiveAuctionDetail;



// components/live-auction/PreviewLiveAuctionDetail.jsx
import React, { useState, useEffect } from "react";
import CircularProgress from "../live-auction/live-auction-detail/ui/CircularProgress";
import QuickBidsDummy from "./QuickBidsDummy";
import BidInput from "../live-auction/live-auction-detail/BidInput";
import VehicleDetails from "../live-auction/live-auction-detail/tables/VehicleDetails";
import VerticleSwiper from "../live-auction/live-auction-detail/ui/VerticleSwiper";
import SwiperMobView from "../live-auction/live-auction-detail/ui/SwiperMobView";
import { FaBagShopping } from "react-icons/fa6";
import { CiLocationOn } from "react-icons/ci";
import { MdPeopleAlt } from "react-icons/md";
import TooltipGlobal from "../live-auction/live-auction-detail/ui/tooltip/TooltipGlobal";
import {
  IoInformationCircleOutline,
  IoVolumeHigh,
  IoVolumeMute,
} from "react-icons/io5";
import SimpleCircularTimer from "./SimpleCircularTimer";
import { ClipLoader } from "react-spinners";
import AuctionBidDetailsShimmer from "./AuctionBidDetailsShimmer";

const PreviewLiveAuctionDetail = ({ car, loading }) => {
  const [manualBid] = useState(car?.currentBid || 0);
  const [countdown, setCountdown] = useState("");

  useEffect(() => {
    if (!car?.auction_date) return;
    const targetDate = new Date(car.auction_date);

    const interval = setInterval(() => {
      const now = new Date();
      const diff = targetDate - now;

      if (diff <= 0) {
        setCountdown("Auction Started");
        clearInterval(interval);
        return;
      }

      const minutes = Math.floor((diff / 1000 / 60) % 60);
      const seconds = Math.floor((diff / 1000) % 60);
      setCountdown(`${minutes} min ${seconds} sec`);
    }, 1000);

    return () => clearInterval(interval);
  }, [car?.auction_date]);

  if (loading) {
    return <AuctionBidDetailsShimmer loading={false} />;
  }

  return (
    <div className="bg-gray-100 w-full py-[3vw] mt-[4vw]">
      <div className="w-[90%] lg:max-w-[85vw] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-[1vw]">
        {/* Left Section */}
        <div className="col-span-7 space-y-[1vw]">
          {/* Header */}
          <div className="flex flex-wrap lg:flex-nowrap justify-between mt-16 lg:mt-0 items-center bg-white p-[1vw] rounded-md">
            <div className="flex items-center">
              <h2 className="lg:text-[1.5vw] font-bold mr-4 lg:mr-[0.5vw]">
                {car?.make} {car?.model} {car?.year}
              </h2>
              <div className="bg-yellow-200 text-gray-800 px-[0.75vw] py-[0.25vw] rounded-full flex items-center lg:text-[1vw]">
                <CiLocationOn className="mr-[0.5vw]" />
                {car?.carState} {car?.carLocation}
              </div>
            </div>
            <div className="flex items-center gap-[0.5vw] lg:text-[1vw] text-gray-700">
              <MdPeopleAlt />
              <span>1</span>
            </div>
          </div>

          <div className="lg:w-[25%] lg:hidden w-full">
            <SwiperMobView images={car?.carImages} />
          </div>

          {/* Images and Bidding UI */}
          <div className="flex gap-[1vw] items-start">
            <div className="lg:w-[25%] lg:block hidden w-full h-[23vw] ">
              <VerticleSwiper images={car?.carImages || []} />
            </div>

            <div className="w-[100%] lg:w-[40vw] bg-white p-[8px] lg:p-[0.8vw] h-full rounded-md shadow-sm flex lg:flex-row justify-between gap-[1vw]">
              {/* Timer + Bid Controls */}
              <div className="flex flex-col justify-center items-center w-full lg:w-1/2 space-y-[0.5vw]">
                <h2 className="font-lg lg:mt-3">Going Live In:</h2>
                <div className="relative flex justify-center items-center lg:ml-8 lg:mt-6">
                  <SimpleCircularTimer auctionDate={car?.auction_date} />
                </div>
                <div className="flex items-center gap-[0.5vw] mt-[0.5vw]">
                  <input
                    value={manualBid}
                    readOnly
                    disabled
                    className="w-[40px] lg:w-[4vw] border border-gray-300 bg-gray-200 text-gray-500 rounded text-center lg:text-[1vw] cursor-not-allowed"
                  />
                  <button
                    disabled
                    className="w-[40px] lg:w-full lg:text-[1vw] border border-gray-300 bg-gray-200 text-gray-500 px-[0.5vw] py-[0.25vw] rounded cursor-not-allowed"
                  >
                    −
                  </button>
                  <button
                    disabled
                    className="w-[40px] lg:w-full lg:text-[1vw] border border-gray-300 bg-gray-200 text-gray-500 px-[0.5vw] py-[0.25vw] rounded cursor-not-allowed"
                  >
                    +
                  </button>
                </div>
              </div>

              {/* Quick Bids Section */}
              <div className="w-full lg:w-1/2 p-[1vw] flex justify-end">
                <QuickBidsDummy manualBid={manualBid} setManualBid={() => {}} />
              </div>
            </div>
          </div>

          {/* Place Bid & Auto-Bid */}
          <div className="flex flex-col items-end mt-[1vw]">
            <div className="w-[100%] lg:w-[75%] rounded-md shadow-sm">
              <button
                disabled
                className="w-full text-[12px] lg:text-18 flex items-center justify-center gap-2 py-[10px] lg:py-[0.677vw] bg-gray-200 text-gray-500 border border-gray-300 rounded-md md:rounded-[0.5vw] cursor-not-allowed"
              >
                <FaBagShopping />
                Place Bid
              </button>

              <div className="mt-[1vw]">
                <label className="lg:text-[1vw] text-left font-medium block mb-[0.5vw]">
                  Auto Bid For Me
                </label>
                <div className="flex items-center border rounded-md md:rounded-[0.5vw] px-3 py-2 bg-white w-full">
                  <input
                    type="text"
                    disabled
                    placeholder="Enter maximum amount"
                    className="focus:outline-none text-[12px] lg:text-16 p-[1vw] lg:py-[0.317vw] bg-gray-200 border border-gray-300 text-gray-500 w-full rounded cursor-not-allowed"
                  />
                  <TooltipGlobal
                    title="Dynamic Bidding Guide"
                    description="The incremental bid based on the vehicles value is as follows:"
                    tableData={[
                      { range: "1 - 5", increment: "1" },
                      { range: "5 - 40", increment: "5" },
                      { range: "40 - 100", increment: "10" },
                      { range: "100 - 1,000", increment: "25" },
                      { range: "1,000 - 5,000", increment: "50" },
                      { range: "5,000 - 25,000", increment: "100" },
                      { range: "25,000 - 50,000", increment: "250" },
                      { range: "50,000 - 100,000", increment: "500" },
                      { range: "100,000 - 9,999,999", increment: "1,000" },
                    ]}
                    customStyles={{
                      color: "#fff",
                      headerStyles: { fontSize: "18px" },
                      paragraphStyles: { fontSize: "14px", color: "#fff" },
                    }}
                    placement="left"
                    hoverComponent={
                      <span className="cursor-pointer text-[14px] lg:text-20">
                        <IoInformationCircleOutline />
                      </span>
                    }
                  />
                </div>
              </div>
            </div>
            <div className="flex items-start space-x-1 w-[100%] lg:w-[75%] lg:mt-[1vw]">
              <button
                disabled
                className="px-2 lg:px-[0.5vw] py-1 lg:py-[0.25vw] rounded-md md:rounded-[0.5vw] bg-gray-400 text-[12px] my-[10px] lg:my-auto lg:text-14"
              >
                Enable Auto-Bid
              </button>
              <button
                disabled
                className="px-2 lg:px-[0.5vw] py-1 lg:py-[0.25vw] rounded-md md:rounded-[0.5vw] text-[12px] my-[10px] lg:text-14 bg-gray-600 text-white hover:bg-gray-700"
              >
                Disable Auto-Bid
              </button>
            </div>
          </div>
        </div>

        {/* Right Section */}
        <div className="col-span-5">
          <VehicleDetails vehicle={car} />
        </div>
      </div>
    </div>
  );
};

export default PreviewLiveAuctionDetail;
